import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  client_inactive,
  client_active,
  home_active,
  home_Deactive,
  recharge_active,
  recharge_inactive,
  withdraw_active,
  withdraw_inactive,
  report_active,
  report_inactive,
} from "../../assets/img";
import useStore from "../../Screen/redux/store/useStore";
// Firebase v9 imports
import {
  ref,
  onValue,
  off,
} from "firebase/database";
import { db } from "../../Services/firebase";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("home");
  const { role, user } = useStore();
  const [permissions, SetPermissions] = useState([]);

  useEffect(() => {
    const todayDate = new Date();
    const formattedDate = todayDate.toISOString().split("T")[0];

    if (!formattedDate) return;

    const resultRef = ref(db, `/admin/${user?.id}/permissions`);
//     console.log("resultRef", resultRef);

    const handleResult = (snapshot) => {
      const data = snapshot.val();
      if (!data) return;
      const arrayData = Object.values(data).filter(item => item !== null);
      SetPermissions(arrayData);
//       console.log("arrayData", arrayData);

    };


    onValue(resultRef, handleResult);

    return () => {
      off(resultRef, "value", handleResult);
    };
  }, []);

//   console.log("Footer permissions:", permissions);

  const pathToTab = {
    "/mobile-navbar": "home",
    "/client-list": "clients",
    "/recharge-history": "recharge",
    "/withdraw-history": "withdraw",
    "/report": "report",
  };

  const tabs = [
    {
      id: "home",
      label: "Home",
      route: 'home',
      path: "/mobile-navbar",
      activeIcon: home_active,
      inactiveIcon: home_Deactive,
    },
    {
      id: "client",
      label: "Client List",
      path: "/client-list",
      route: 'clients',
      activeIcon: client_active,
      inactiveIcon: client_inactive,
    },
    {
      id: "recharge_history",
      label: "Recharge",
      path: "/recharge-history",
      route: 'recharge',
      activeIcon: recharge_active,
      inactiveIcon: recharge_inactive,
    },
    {
      id: "widraw_history",
      label: "Withdraw",
      path: "/withdraw-history",
      route: 'withdraw',
      activeIcon: withdraw_active,
      inactiveIcon: withdraw_inactive,
    },
    {
      id: "reports",
      label: "Report",
      path: "/report",
      route: 'report',
      activeIcon: report_active,
      inactiveIcon: report_inactive,
    },
  ];

  const getTabPermission = (tabId) => {
//     console.log("Checking permission for tab:", tabId);
    if (tabId === 'home') return true;
    if (role === true) return true;

    const perm = permissions.find(
      (p) => p.module_code === tabId
    );
    return !!perm;
  };

  useEffect(() => {
    const currentTab = pathToTab[location.pathname] || "home";
    setActiveTab(currentTab);
  }, [location.pathname]);




  return (
    <div className="footer-container">
      {tabs.map((tab) => {
        const hasPermission = getTabPermission(tab.id);
        return (
          <div
            key={tab.route}
            className={`footer-item ${activeTab === tab.route ? "active" : ""} ${!hasPermission ? "disabled" : ""
              }`}
            onClick={() => hasPermission && navigate(tab.path, { state: { fromFooter: true } })}
          >
            <img
              src={activeTab === tab.route ? tab.activeIcon : tab.inactiveIcon}
              width={22}
              height={22}
              alt={tab.label}
            />
            <p className="footer-label">{tab.label}</p>
          </div>
        );
      })}
    </div>
  );
};

export default Footer;
